import React from 'react';
import { Link, useParams, useSearchParams } from 'react-router-dom';
import WebsiteTopBar from '../../components/WebsiteTopBar';
import LogisticsGenericRfqPage from './LogisticsGenericRfqPage';
import BusinessRelocationRfqPage from './BusinessRelocationRfqPage';
import ExhibitionLogisticsRfqPage from './ExhibitionLogisticsRfqPage';
import 'bootstrap/dist/css/bootstrap.min.css';
import '../../assets/styles/website-top-bar.scss';

const RFQ_META = {
  generic: { title: 'Generic RFQ', description: 'RFQ form for this flow will be added here.' },
  'business-relocation': {
    title: 'Business Relocation RFQ',
    description: 'RFQ form for business relocation will be added here.',
  },
  'exhibition-logistics': {
    title: 'Exhibition Logistics RFQ',
    description: 'RFQ form for exhibition logistics will be added here.',
  },
};

export default function LogisticsRfqPlaceholderPage() {
  const { rfqKind } = useParams();
  const [searchParams] = useSearchParams();
  const meta = RFQ_META[rfqKind];

  if (rfqKind === 'generic') {
    return <LogisticsGenericRfqPage />;
  }

  if (rfqKind === 'business-relocation') {
    return <BusinessRelocationRfqPage />;
  }

  if (rfqKind === 'exhibition-logistics') {
    return <ExhibitionLogisticsRfqPage />;
  }

  const companyIdRaw = searchParams.get('companyId');
  const companyIdNum = companyIdRaw != null ? parseInt(String(companyIdRaw), 10) : NaN;
  const companyIdLabel =
    Number.isFinite(companyIdNum) && companyIdNum > 0 ? `Provider company ID: ${companyIdNum}` : null;

  return (
    <div className="min-vh-100" style={{ background: '#f5f7fb' }}>
      <WebsiteTopBar />
      <div className="container py-5">
        <nav className="mb-3">
          <Link to="/logistics-providers" className="text-decoration-none fw-semibold">
            ← Back to logistics providers
          </Link>
        </nav>
        {meta ? (
          <>
            <h1 className="h3 fw-bold text-dark mb-2">{meta.title}</h1>
            {companyIdLabel ? (
              <p className="small text-secondary mb-2">{companyIdLabel}</p>
            ) : null}
            <p className="text-muted mb-0">{meta.description}</p>
          </>
        ) : (
          <>
            <h1 className="h3 fw-bold text-dark mb-2">Not found</h1>
            <p className="text-muted mb-3">This RFQ type is not available.</p>
            <Link to="/logistics-providers" className="btn btn-primary">
              Back to directory
            </Link>
          </>
        )}
      </div>
    </div>
  );
}
